/* eslint-disable @typescript-eslint/naming-convention */
export const __expensivePriceThreshold__ = 8
export const __hardElecPrice__ = 0.07
export const __syneString__ = 'YYYY-MM-DDTHH:mm:ss'
export const __syneNPSStringTo__ = 'YYYY-MM-DDTHH:00:01'
export const __syneNPSStringFrom__ = 'YYYY-MM-DDTHH:00:00'

// We declare the Consumer paid Electric tax which is 2.917875 cents per kWh starting 1.4.2026
export const _electricTaxPerKwh = 2.917875

export const nokInEur = 0.088

export const minAcceptedHvacTemperature = 15
export const normalHvacTemperature = 21
export const maxAcceptedHvacTemperature = 28

export const CO2_PER_KWH = 0.025 // Updated as of 10.6.2026 https://www.fingrid.fi/en/electricity-market-information/real-time-co2-emissions-estimate Can be used to update
